import { QueryObserver } from '@tanstack/react-query';
import { assign, sendParent } from 'xstate';
import { alternatePaymentMethodsCacheKey, queryFnFactory } from '@syf-api-library/alternate-payment-methods';
import fetchMachine from './fetchMachine';
const ASSIGN_ACTION = assign({
    alternatePaymentMethodsQueryResult: ({ alternatePaymentMethodsQueryResult }, event) => {
        const [, data] = event.data;
        return Object.assign(Object.assign({}, alternatePaymentMethodsQueryResult), { data });
    }
});
export const sendAlternatePaymentMethodsSuccessToParent = sendParent((context, event) => {
    return Object.assign(Object.assign({}, event), { type: 'AFTER_ALTERNATE_PAYMENT_METHODS_FETCH' });
});
const alternatePaymentMethods = {
    type: 'parallel',
    states: {
        querySubscription: {
            invoke: {
                src: ({ apiConfig, queryClient }) => {
                    const queryKey = alternatePaymentMethodsCacheKey(apiConfig.keyProps);
                    const queryObserver = new QueryObserver(queryClient, {
                        queryKey,
                        queryFn: queryFnFactory(apiConfig.config, apiConfig.keyProps),
                        enabled: true
                    });
                    const subscribe = (next) => {
                        const unsubscribe = queryObserver.subscribe((event) => {
                            if (event.isLoading === false && event.isSuccess === true) {
                                const data = [queryKey, event.data];
                                next({ type: 'SET_ALTERNATE_PAYMENT_METHODS', data });
                            }
                        });
                        return {
                            unsubscribe
                        };
                    };
                    return {
                        subscribe
                    };
                }
            }
        },
        api: {
            initial: 'idle',
            states: {
                idle: {},
                fetching: {
                    invoke: {
                        src: fetchMachine,
                        data: {
                            // initialize fetchMachine with context values
                            cacheKey: ({ apiConfig }) => alternatePaymentMethodsCacheKey(apiConfig.keyProps),
                            queryClient: ({ queryClient }) => queryClient,
                            queryFn: ({ apiConfig }) => queryFnFactory(apiConfig.config, apiConfig.keyProps)
                        },
                        onDone: {
                            target: 'success',
                            actions: ASSIGN_ACTION
                        },
                        onError: {
                            target: 'error',
                            actions: assign({
                                alternatePaymentMethodsQueryResult: ({ alternatePaymentMethodsQueryResult }, event) => {
                                    const [, error] = event.data;
                                    return Object.assign(Object.assign({}, alternatePaymentMethodsQueryResult), { error });
                                }
                            })
                        }
                    },
                    on: {
                        FETCH_PAYMENT_METHODS: undefined
                    }
                },
                success: {
                    entry: 'sendAlternatePaymentMethodsSuccessToParent'
                },
                error: {
                    entry: 'sendErrorToParent'
                }
            }
        }
    },
    on: {
        FETCH_ALTERNATE_PAYMENT_METHODS: {
            target: '#apiMachine.alternatePaymentMethods.api.fetching',
            actions: ({ apiConfig, queryClient }, { force }) => {
                if (force) {
                    queryClient.invalidateQueries(alternatePaymentMethodsCacheKey(apiConfig.keyProps));
                }
            }
        },
        SET_ALTERNATE_PAYMENT_METHODS: {
            target: '#apiMachine.alternatePaymentMethods.api.success',
            actions: ASSIGN_ACTION
        }
    }
};
export default alternatePaymentMethods;
